import { render, staticRenderFns } from "./MonitoringAudiences.vue?vue&type=template&id=12e00487&lang=pug"
import script from "./MonitoringAudiences.vue?vue&type=script&lang=js"
export * from "./MonitoringAudiences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports